import { trackCommuteTime } from 'shared_critical/tracking/shared/special_events';
import { trackClick } from 'shared_critical/tracking/shared/clicks';
import car_icon from "../../images/car-ic.svg"

MOVE.CommuteTime = (function(MOVE) {
  var $ldpCommuteTimePopover,
      $ldpCommuteTimeClose,
      $commuteForm,
      ldpCommuteTimeSelector,
      ldpCommuteAddressSelector,
      $ldpCommuteTime,
      $ldpCommuteAddress,
      $commuteTrafficOption,
      $commuteDrive,
      closeCommuteTimePopover,
      smartyStreetLiveAddress,
      $commuteInfo,
      $commutePopoverInfo,
      smartyUIInit,
      scrollPosition,
      viewport;

  var init = function(){
    setVariables();
    initLiveAddress();
    checkTrafficOption();
    MOVE.DOMHelper.initPopOver($commuteInfo);
  };

  var setVariables = function() {
    $ldpCommuteTimePopover    = $('#estimate-commute-time-popover');
    $ldpCommuteTimeClose      = $('#ldp-commute-time-close');
    $commuteForm              = $('#commute-form');
    ldpCommuteTimeSelector    = '#ldp-commute-time';
    ldpCommuteAddressSelector = '#ldp-commute-address';
    $ldpCommuteTime           = $(ldpCommuteTimeSelector);
    $ldpCommuteAddress        = $(ldpCommuteAddressSelector);
    $commuteTrafficOption     = $("#commute-traffic");
    $commuteDrive             = $('#ldp-commute-time-drive');
    $commuteInfo              = $("#estimate-commute-time-popover");
    $commutePopoverInfo       = $commuteInfo.find('[rel="popover"]');
    smartyUIInit              = false;
    viewport                  = MOVE.Helper.detectViewPort();
    if ($ldpCommuteTime.length > 0) {
      scrollPosition = $ldpCommuteTime.offset().top;
    }


    // Init SmartyStreet
    smartyStreetLiveAddress = MOVE.SmartyStreetSuggest.liveAddressSuggest({
      addresses: [{
        freeform: ldpCommuteAddressSelector
      }]
    });

    closeCommuteTimePopover = function(){
      if (smartyStreetLiveAddress) {
        if ($ldpCommuteTimePopover.hasClass('show-commute') && viewport === 'xx-small') {
          window.scrollTo(0, scrollPosition - 150);
        }
        smartyStreetLiveAddress.deactivate('ldp-commute-address');
        $ldpCommuteTimePopover.removeClass('show-commute');
        clearError();
      }
    };
  };

  var initLiveAddress = function() {
    $ldpCommuteAddress.focus(function(){
      clearError();
      closeCommuteInfoPopover();
    });

    $commuteForm.submit(function (e) {
      e.preventDefault();
      return false;
    });

    $ldpCommuteTimePopover.on('click', 'button', function(){
      if($('.ldp-commute-time-search .ldp-commute-address').val() === ''){
        noCommuteResults('EMPTY_VALUE');
      }else{
        estimateCommuteTime(true);
      }
      closeCommuteInfoPopover();
    });

    $ldpCommuteTimePopover.on('click', '.ldp-commute-mode i', function(){
      $('.estimate-commute-time-content i').removeClass('selected');
      $('.estimate-commute-time-content img').removeClass('selected');
      $(this).addClass('selected');
      checkTrafficOption();
    });

    $ldpCommuteTimePopover.on('click', '.ldp-commute-mode img', function(){
      $('.estimate-commute-time-content i').removeClass('selected');
      $('.estimate-commute-time-content img').removeClass('selected');
      $(this).addClass('selected');
      checkTrafficOption();
    });

    $ldpCommuteTimeClose.click(function(){
      closeCommuteTimePopover();
    });

    $('body').on('click', function (e) {
      var container = $('#estimate-commute-time-popover');
      if (!container.is(e.target) && container.has(e.target).length === 0 ) {
        closeCommuteTimePopover();
        closeCommuteInfoPopover();
      }

    }).find('.commute-time-wrapper').on('click', function (event) {
      event.stopPropagation();
    });

    $ldpCommuteTime.on('click', '.estimate-commute-popover-toggle', function(){
      var popoverContainer =  $ldpCommuteTimePopover;
      if(popoverContainer.hasClass('show-commute')){
        closeCommuteTimePopover();
      }
      else {
        if (MOVE.Helper.hasSessionStorage()) {
          var commuteTimeTraffic = window.sessionStorage.getItem(
            'commutetime-traffic'
          );

          if (commuteTimeTraffic !== null) {
            $('#commutetraffic').prop('checked', commuteTimeTraffic === 'true');
          }
        }

        popoverContainer.addClass('show-commute');
        $ldpCommuteAddress.focus();
        smartyStreetLiveAddress.activate('ldp-commute-address');
        $(window).resize();// This line helps to make sure the smarty autocomplete goes under the input field
        setDestinations();

        // This allow us to bind only one event to .smarty-ui div,
        // otherwise we will have more click events binded on each click
        if(!smartyUIInit) {
          $('.smarty-ui').on('click', function (event) {
            event.stopPropagation();
          });
          smartyUIInit = true;
        }
      }
      const pageType = MOVE_DATA.adobeDTM.pageType;
      trackClick('property-info:calculate-commute', pageType);
    });

    $ldpCommuteTimePopover.on('change', '#commutetraffic', function() {
      if (MOVE.Helper.hasSessionStorage()) {
        window.sessionStorage.setItem(
          'commutetime-traffic', $('#commutetraffic').is(':checked')
        );
      }
    });
  };

  var noCommuteResults = function(errorMessage, mode) {
    var errorLabel = $('.commute-time-invalid-address');
    if (errorMessage === 'ZERO_RESULTS' || errorMessage === 'NOT_FOUND'){
      errorLabel.text('Sorry, we could not calculate '+  mode + ' directions.');
    } else if (errorMessage === 'COOKIES_NOT_ENABLED') {
      errorLabel.text('Your browser has to support cookies.');
    } else if (errorMessage === 'STALE_COOKIES') {
      errorLabel.text('Please refresh the browser.');
    } else if (errorMessage === 'EMPTY_VALUE') {
      errorLabel.text('Please enter a valid address.');
    }
    errorLabel.addClass('error').fadeIn();
  };

  var clearError = function(){
    var errorLabel = $('.commute-time-invalid-address');
    if (errorLabel.hasClass('error')){
      errorLabel.fadeOut().removeClass('error');
      $('.smarty-ui').removeClass('error');
    }
  };

  var estimateCommuteTime = function(isClick){
    var origins    = MOVE_DATA.propertyDetails.address + ' ' +
                     MOVE_DATA.propertyDetails.city + ' ' +
                     MOVE_DATA.propertyDetails.state_code + ' ' +
                     MOVE_DATA.propertyDetails.postal_code,
      destinations = $('.ldp-commute-time-search .ldp-commute-address').val(),
      element      = $('.estimate-commute-time-content i.selected'),
      mode         = element.data('commute-mode');

    if (destinations && mode) {
      var commuteMode = element.data('icon'),
          departureTime;

      if (mode === 'driving') {
        departureTime = Math.round(nextWednesday().getTime() / 1000.0);
      }

      $.ajax({
        url:      '/commute/time',
        type:     'POST',
        data:     $.param({
                    origins:        origins,
                    destinations:   destinations,
                    mode:           mode,
                    departure_time: departureTime
                  }),
        dataType: 'json',
        success: function(response) {
          // duration_in_traffic is only available when departure_time present
          var duration = response.rows[0].elements[0].duration_in_traffic || response.rows[0].elements[0].duration;

          if(!_.isUndefined(duration)) {
            var durationTxt = duration.text;
            renderCommuteTime(commuteMode, durationTxt);
            cacheDestinations(destinations);
            closeCommuteTimePopover();

            if (MOVE.Helper.hasSessionStorage()) {
              window.sessionStorage.setItem(
                'commutetime-mode', element.attr('id')
              );
            }

          } else {
            noCommuteResults(response.rows[0].elements[0].status , mode);
          }
          if(isClick) {
            var commuteOption;
            if (commuteMode === 'car') {
              commuteOption = departureTime ? 'driveWithTraffic' : 'driveWithoutTraffic';
            } else {
              commuteOption = commuteMode;
            }
            MOVE_DATA.adobeDTM.commuteAddress = destinations;
            MOVE_DATA.adobeDTM.commuteOption = commuteOption;

            trackCommuteTime(MOVE_DATA.adobeDTM.pageType, destinations, commuteOption);
          }
        },
        error: function(response){
          if( response.responseText !== undefined ) {
            noCommuteResults(response.responseText, mode);
          } else {
            noCommuteResults();
          }
        }
      });
    }
  };

  var cacheDestinations = function(destinations){
    if (MOVE.LocalStorage.isAvailable) {
      localStorage.setItem('commuteDestinations', destinations);
    }
  };

  var setDestinations = function(){
    if (MOVE.LocalStorage.isAvailable) {
      var destinations = localStorage.getItem('commuteDestinations');
      if (destinations){
        $('.ldp-commute-time-search .ldp-commute-address').val(destinations);
      }
    }
  };

  var setMode = function(){
    if (MOVE.Helper.hasSessionStorage()) {
      var modeSelectorId = window.sessionStorage.getItem('commutetime-mode');
      if (modeSelectorId) {
        $('#' + modeSelectorId).addClass('selected').siblings().removeClass('selected');
      }
    }
  };

  var closeCommutePopover = function() {
    var commutePopover = $('#estimate-commute-time-popover');
      if(commutePopover.is(":visible")){
        closeCommuteTimePopover();
      }
  };

  var checkTrafficOption = function(){
    if( $commuteDrive.hasClass('selected')){
      $commuteTrafficOption.removeClass('no-show');
    }
    else{
      $commuteTrafficOption.addClass('no-show');
      closeCommuteInfoPopover();
    }
  };

  var closeCommuteInfoPopover = function(){
    $commutePopoverInfo.popover('hide');
  };

  var nextWednesday = function() {
    var day = new Date();

    // Set day to next Wednesday and set hours to 8:00 AM
    // if today is already Wednesday, set the day to Wednesday of next week
    day.setDate(day.getDate() + (9 - day.getDay()) % 7 + 1);
    day.setHours(8, 0, 0);

    return day;
  };

  var loadCommuteTime = function() {
    if (MOVE.Helper.hasSessionStorage()) {
      setDestinations();
      setMode();
      estimateCommuteTime(false);
    }
  };

  var renderCommuteTime = function(mode, duration) {
    const isGraphicalUplift = MOVE_DATA.visual_update_replatform === 'V1' && !MOVE_DATA.ab_vitality;
    let commuteIcon = (isGraphicalUplift && mode === 'car') ? '<i class="margin-right"><img src="'+ car_icon + '" ></i>'
      : '<i class="margin-right ra ra-' + mode + '"></i>'
    $('.ldp-commute-icon').addClass('hide');
    $('.estimate-commute-popover-toggle').html(
      commuteIcon + duration
    );
  };

  MOVE.CommuteTime =
  {
    init: init,
    closeCommutePopover: closeCommutePopover,
    loadCommuteTime: loadCommuteTime
  };

  return MOVE.CommuteTime;

})(MOVE || {});



// WEBPACK FOOTER //
// ./shared_critical/_commute_time.js